import React from 'react';
import { EventsUpcoming } from 'src/domains/sportsbook/webview/components/containers/eventsUpcoming/EventsUpcoming';
import { InPlay } from 'src/domains/sportsbook/webview/components/containers/eventsInPlay/EventsInPlay';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { EventsCollectionState } from 'src/domains/sportsbook/state/eventsCollection/EventsCollectionState';

interface PropsType {
    showPriceLegend: boolean;
}

export const EventsInPlayOrUpcoming = observer('EventsInPlayOrUpcoming', ({ showPriceLegend }: PropsType) => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;
    const isLoading = EventsCollectionState.get(common).listInPlay.isLoading;

    if (isLoading) {
        return (
            <InPlay
                showPriceLegend={showPriceLegend}
                isLoading={true}
            />
        );
    } else if (EventsCollectionState.get(common).listInPlay.isEmpty === true) {
        if (config.startingSoonEvents === false) {
            return (
                <EventsUpcoming
                    showPriceLegend={showPriceLegend}
                    isLoading={false}
                />
            );
        }
    }
    return (
        <InPlay
            showPriceLegend={showPriceLegend}
            isLoading={false}
        />
    );
});
